import appConf from "../app-conf";
const setup = appConf[process.env.REACT_APP_CLIENT];
const environment = process.env.NODE_ENV;
const project = "Account Activation";
const server = null;
const service = null;
const options = {
  preference_options: [
    { name: "Preference Type 1", value: "1" },
    { name: "Preference Type 2", value: "2" },
  ],
};
const config = {
  details: {
    project,
    server,
    environment,
    service,
  },
  application: {
    config: {
      api: {
        endpoints: {
          forgotpasswordsubmitupdate: {
            headers: {
              "Content-Type": "application/json",
              moduleCode:
                setup.setup.westfield.corp.norm.moduleCode[environment],
            },
            doc: "https://tr4ns10.tr4ns.com/Westfield-Reporting",
            //url: "/Westfield-Reporting/report21?",
            url:
              setup.setup.api.tranxactor_westfield_corp.url[environment] +
              "/password",
            method: "PUT",
          },
          auth: {
            headers: {
              "Content-Type": "application/json",
              moduleCode:
                setup.setup.westfield.corp.norm.moduleCode[environment],
            },
            doc: "http://tr4ns10.tr4ns.com/Westfield-BulkOrder/auth/token",
            url:
              setup.setup.api.tranxactor_westfield_bulkorder.url[environment] +
              "/auth/token",
            method: "POST",
          },
        },
      },
      objects: {
        password: {
          name: "password",
          initial: "",
          label: "Password",
          helperText: false,
          rules: ["isNotNull", "isPasswordStrength"],
        },
        passwordconfirm: {
          name: "passwordconfirm",
          initial: "",
          label: "Confirm password",
          helperText: false,
          rules: ["isNotNull", "isConfirm"],
          confirm_to: "password",
          confirm_suffix: "password",
        },
      },
      responses: {
        fail: "No such username or password",
        unverified: "Please verify your account by ticking the recaptcha.",
      },
    },
  },
  routes: {
    label: "Submit New Password",
    prefix: "/corporate/forgot_password/submit/:activationToken",
  },
  setup,
};

export default config;
